import { selectFeatureFlag } from '@gandi/authentication';
import { useAppSelector } from './useAppSelector';
export const useFeatureFlag = featureFlagName => {
  const featureFlag = useAppSelector(state => selectFeatureFlag(state, {
    featureFlagName
  }));
  return featureFlag;
};